import angular, { IPromise } from "angular";

import { vsComponentName as lookupEditModalComponentOptionsName } from "./component";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../server/serverUtility";
import { IQueryResponse } from "../../server/query";
import { LookupManagementConfig } from "../lookupManagement";
import {
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../views/recordGridView";

export const vsServiceName = "LookupEditModalService";

export interface LookupEditModalOptions {
  lookupManagementConfig: LookupManagementConfig;
  lookupId: number;
}

export class LookupEditModalService {
  static $inject = ["$uibModal", ServerUtilityName, RecordGridViewServiceName];

  constructor(
    private readonly $uibModal: angular.ui.bootstrap.IModalService,
    private readonly serverUtility: ServerUtility,
    private readonly recordGridViewService: RecordGridViewService
  ) {}

  openModal(
    config: LookupEditModalOptions
  ): IPromise<angular.ui.bootstrap.IModalInstanceService> {
    const gridConfiguration = this.recordGridViewService.getGridConfiguration(
      config.lookupManagementConfig.name!
    )!;

    return this.getSimilarItems(
      config.lookupManagementConfig,
      gridConfiguration
    ).then((similarItemList) => {
      var similarItems: Array<any> = similarItemList.filter(
        (i: any) => i.id != config.lookupId
      );

      return this.$uibModal.open({
        component: lookupEditModalComponentOptionsName,
        resolve: {
          similarItems: () => similarItems,
          lookupManagementConfig: () => config.lookupManagementConfig,
          lookUpId: () => config.lookupId,
        },
      });
    });
  }
  getSimilarItems(
    lookupManagementConfig: LookupManagementConfig,
    gridConfiguration: GridConfiguration
  ) {
    const nameGetter =
      lookupManagementConfig.getLongItemDisplay ?? ((item: any) => item.Name);
    const lookupItemMapper = (item: any) => {
      return { id: item.Id, name: nameGetter(item) };
    };
    var response = this.serverUtility
      .sendApiRequest<IQueryResponse<any>>({
        method: "get",
        url: lookupManagementConfig.baseUrl,
        params: {
          OrderBy: gridConfiguration.defaultSort ?? "Name",
          Take: 1000,
        },
      })
      .then((r) => r.Results.map(lookupItemMapper));
    return response;
  }
}
